var map = {
	"./3tech.svg": "53a1",
	"./404.svg": "49be",
	"./CustomerWasUpdated.svg": "e31a",
	"./DownPaymentWasCreated.svg": "7b34",
	"./DownPaymentWasPaid.svg": "b51e",
	"./LogoNavBar.svg": "a5ee",
	"./LogoNavBarAr.svg": "5fc3",
	"./OrderWasApproved.svg": "0eb0",
	"./OrderWasAuthorised.svg": "28de",
	"./OrderWasCanceled.svg": "d90f",
	"./OrderWasCaptured.svg": "7f03",
	"./OrderWasCreated.svg": "2d75",
	"./OrderWasOverdue.svg": "9ed6",
	"./OrderWasPaid.svg": "8b9d",
	"./OrderWasRefunded.svg": "4bc2",
	"./PaymentWasRefunded.svg": "36b6",
	"./accessories.svg": "04a4",
	"./account-collapsed.svg": "d26d",
	"./account-small.svg": "4944",
	"./account.svg": "1533",
	"./active-menu-icon.svg": "66d2",
	"./add-circle-white.svg": "d465",
	"./add-circle.svg": "201e",
	"./admin.svg": "525e",
	"./ads-credit-small.svg": "7de0",
	"./ads-credit.svg": "a427",
	"./ads-error.svg": "672e",
	"./ads-information.svg": "6ce9",
	"./ads-success.svg": "e66a",
	"./ads-warning-credit.svg": "ef15",
	"./ads-warning.svg": "c79c",
	"./advanced-filter.svg": "59df",
	"./advertising.svg": "7f1a",
	"./ae.svg": "ec27",
	"./alert-circle.svg": "bb56",
	"./alert.svg": "e6c5",
	"./all-segment-active.svg": "fa8c",
	"./all-segment.svg": "0c9a",
	"./angle-right.svg": "8cbd",
	"./api-active.svg": "2014",
	"./api-link.svg": "8183",
	"./api.svg": "c812",
	"./appliances.svg": "06d5",
	"./approval-code.svg": "948c",
	"./arrow-cycle.svg": "8e49",
	"./arrow-down.svg": "f66a",
	"./arrow-left-right.svg": "b206",
	"./arrow-left.svg": "51b5",
	"./arrow-out.svg": "5baa",
	"./arrow-right-gray.svg": "2721",
	"./arrow-right.svg": "55b9",
	"./aumet.svg": "b4c6",
	"./auto.svg": "0907",
	"./babies.svg": "4bd1",
	"./bank.svg": "1ddb",
	"./banner-close.svg": "57b6",
	"./bd.svg": "63a8",
	"./beauty-active.svg": "f109",
	"./beauty.svg": "af15",
	"./bh.svg": "2621",
	"./big-basket-shoppers-active.svg": "2bc5",
	"./big-basket-shoppers.svg": "23ad",
	"./books.svg": "8342",
	"./boost-sales.svg": "1cb2",
	"./breakdown-arrow-right.svg": "54b1",
	"./calendar-black.svg": "ecca",
	"./calendar-gray.svg": "092e",
	"./calendar.svg": "287d",
	"./campaign-ended-status.svg": "6b36",
	"./campaign-need-action-status.svg": "26ee",
	"./campaign-ongoing-status.svg": "4b32",
	"./campaign-paused-status.svg": "f3d8",
	"./campaign-pending-status.svg": "bd6f",
	"./card.svg": "0cb1",
	"./ccavenues.svg": "e393",
	"./change-branch.svg": "1975",
	"./charities.svg": "52ce",
	"./chat-filled.svg": "1ace",
	"./chat-with-us.svg": "252d",
	"./chat.svg": "a485",
	"./check-circle-active.svg": "74b7",
	"./check-circle-filled.svg": "7700",
	"./check-circle-green.svg": "0aa8",
	"./check-circle-grey-filled.svg": "b94b",
	"./check-circle-new.svg": "1cbd",
	"./check-circle.svg": "9652",
	"./check-empty-small.svg": "ca45",
	"./check-filled.svg": "5d4d",
	"./check-gray.svg": "091b",
	"./check-green-filled.svg": "47a7",
	"./check-green-small.svg": "6c79",
	"./check-green.svg": "5e14",
	"./check-mark.svg": "088c",
	"./check-outline-green.svg": "ca30",
	"./check-round-white.svg": "4284",
	"./check-success.svg": "3fd1",
	"./check-tick.svg": "a9fe",
	"./check-white.svg": "1162",
	"./check.svg": "a7c0",
	"./checkbox-active.svg": "1711",
	"./checkbox-inactive.svg": "b68b",
	"./checked-purple.svg": "c1c2",
	"./checked.svg": "1f78",
	"./chevron-left.svg": "7fc6",
	"./chevron-right.svg": "c5d1",
	"./chevron-up-down.svg": "da36",
	"./circle-check-green.svg": "ec71",
	"./circle-question-mark.svg": "d835",
	"./circle.svg": "77ee",
	"./circled-check.svg": "f107",
	"./clock-1.svg": "6229",
	"./clock-days-left.svg": "3d07",
	"./clock-dispute.svg": "6ee4",
	"./clock-gray.svg": "cc7c",
	"./clock-yellow.svg": "9363",
	"./clock.svg": "9f74",
	"./close-button.svg": "e926",
	"./close-circle.svg": "0c52",
	"./close.svg": "864a",
	"./closed-cases.svg": "fa25",
	"./clothes.svg": "fd3f",
	"./collapse-icon-active.svg": "0ebc",
	"./collapse-icon.svg": "6560e",
	"./coming-icons.svg": "685d",
	"./contact-active.svg": "01af",
	"./contact.svg": "42b2",
	"./copy-grey.svg": "6bfe",
	"./copy-solid.svg": "e948",
	"./copy-white.svg": "87a7",
	"./copy.svg": "c0a5",
	"./creators-home-active.svg": "ec74",
	"./creators-home.svg": "1130",
	"./cross.svg": "e7f7",
	"./cta.svg": "ed0b",
	"./custom-range.svg": "c0d3",
	"./dashboard-active.svg": "0960c",
	"./dashboard.svg": "7154",
	"./date-icon-hover.svg": "acab",
	"./date-icon.svg": "a601",
	"./date-select.svg": "c94a",
	"./default-merchant.svg": "6fc1",
	"./delete.svg": "a3dd",
	"./digital.svg": "1406",
	"./direct-schools.svg": "46fb",
	"./discount-1.svg": "23fd",
	"./discount-filled.svg": "829e",
	"./dispute-event-info.svg": "9d9e",
	"./dispute-event-pending.svg": "29ff",
	"./dispute-green-plus.svg": "5e73",
	"./disputes-active.svg": "4e42",
	"./disputes.svg": "c443",
	"./distributor.svg": "1bba",
	"./docs-tnc.svg": "5e9c",
	"./docs.svg": "0dd7",
	"./document-grey.svg": "683e",
	"./dots-black.svg": "568b",
	"./dots-id-detail.svg": "be7b",
	"./dots-id.svg": "e86a",
	"./dots.svg": "3144",
	"./download-dialog.svg": "e527",
	"./download.svg": "039a",
	"./downtrend.svg": "9113",
	"./edit-filled.svg": "3ffd",
	"./edit-purple-filled.svg": "ff62",
	"./edit-round.svg": "1e54",
	"./edit-white-filled.svg": "d1c1",
	"./edit.svg": "2fb0",
	"./education.svg": "2369",
	"./electronics.svg": "3325",
	"./ellipse.svg": "9521",
	"./email.svg": "caf7",
	"./empower-customers.svg": "73cb",
	"./error-transparent.svg": "caf7c",
	"./error.svg": "7518",
	"./exclamation-grey.svg": "395a",
	"./exclamation-guideline.svg": "e2d6",
	"./exclamation-outline.svg": "2612",
	"./exclamation-red-round.svg": "1430",
	"./exclamation-red.svg": "d816",
	"./exclamation-white.svg": "08a8",
	"./exclamation-yellow-filled.svg": "5359",
	"./exclamation-yellow.svg": "a33e",
	"./exclamation.svg": "3186",
	"./exit-fullscreen.svg": "f22e",
	"./expected-on-default.svg": "449b",
	"./expected-on-red.svg": "bf88",
	"./export.svg": "8354",
	"./exports-active.svg": "392a",
	"./exports.svg": "feef",
	"./external-link-arrow.svg": "5857",
	"./external-link.svg": "f3d4",
	"./external.svg": "7be2",
	"./eye-blue.svg": "be19",
	"./eye-open.svg": "74a2",
	"./eye-round.svg": "2914",
	"./eye.svg": "57fa",
	"./failed.svg": "1d0c",
	"./farah-star.svg": "6fef",
	"./farah.svg": "7b45",
	"./fashionistas-active.svg": "efab",
	"./fashionistas.svg": "5176",
	"./file-settlement.svg": "0cc7",
	"./file-tax.svg": "19fb",
	"./file-type-doc-purple.svg": "2402",
	"./file-type-doc.svg": "847b",
	"./file-upload.svg": "98b4",
	"./file.svg": "493c",
	"./filled-cross.svg": "2d21",
	"./filter-dispute.svg": "e090",
	"./filter.svg": "3663",
	"./financial-service.svg": "6fb1",
	"./flag-ae-square.svg": "eb95",
	"./flag-ae.svg": "c00a",
	"./flag-bh.svg": "048b",
	"./flag-kw.svg": "a4f2",
	"./flag-qa.svg": "0a1b",
	"./flag-sa.svg": "d02e",
	"./freelancer.svg": "8f3d",
	"./fullscreen.svg": "72e5",
	"./games.svg": "c094",
	"./geidea.svg": "e0e0",
	"./gift-givers-active.svg": "dd09",
	"./gift-givers.svg": "424b",
	"./gift.svg": "4b34",
	"./globe-active.svg": "2c45",
	"./globe-gray.svg": "8c03",
	"./globe.svg": "670e",
	"./google-login.svg": "332d",
	"./groceries.svg": "1896",
	"./handshake.svg": "5d4f",
	"./hassle-free-smile.svg": "b708",
	"./headphones.svg": "c47f",
	"./health-care.svg": "7c01",
	"./heart.svg": "fe25",
	"./help-question.svg": "9c7f",
	"./help.svg": "86c0",
	"./helpSign.svg": "6141",
	"./high-spender-active.svg": "b799",
	"./high-spender.svg": "5729",
	"./higher-conversion.svg": "a102",
	"./higher-order-value.svg": "cd81",
	"./home-repair.svg": "f6d8",
	"./home-service.svg": "75f3",
	"./home.svg": "0331",
	"./image-placeholder.svg": "7d83",
	"./in-store-2.svg": "bb65",
	"./in-store-shoppers-active.svg": "f77b",
	"./in-store-shoppers.svg": "dc57",
	"./in-store.svg": "7d7e",
	"./increase.svg": "22c0",
	"./info.svg": "b888",
	"./information.svg": "a60b",
	"./inline-save.svg": "4135",
	"./insights.svg": "23ed",
	"./insurance.svg": "4015",
	"./invoice.svg": "e1de",
	"./kd.svg": "6a73",
	"./kit.svg": "f574",
	"./kw.svg": "b99e",
	"./kyc-action-required.svg": "b7bc",
	"./kyc-checkmark-green.svg": "f4f1",
	"./kyc-checkmark-grey.svg": "249b",
	"./kyc-grey-cross.svg": "3787",
	"./kyc-id.svg": "8538",
	"./kyc-update.svg": "685c",
	"./later.svg": "ea13",
	"./link.svg": "5fda",
	"./loading.svg": "eede",
	"./loyal-customer-active.svg": "d111",
	"./loyal-customer.svg": "3ada",
	"./market.svg": "90b4",
	"./marketplace.svg": "4583",
	"./megaphone-blue.svg": "ff26",
	"./megaphone-yellow.svg": "42b7",
	"./membership.svg": "1cc2",
	"./menu-docs.svg": "c5fa",
	"./minus-red.svg": "677c",
	"./minus.svg": "ae17",
	"./missing-permission.svg": "7631",
	"./money-2.svg": "b877",
	"./money.svg": "4955",
	"./myfatoorah.svg": "3b98",
	"./network-international.svg": "8b05",
	"./network.svg": "74ff",
	"./no-chart.svg": "d8dd",
	"./no-previous-orders.svg": "365a",
	"./no-results-icon.svg": "b0c6",
	"./nomod.svg": "7d8b",
	"./none.svg": "44ea",
	"./note-eye.svg": "1dcb",
	"./notification-close.svg": "455c",
	"./notification-gray.svg": "e4d4",
	"./notification-icon-success.svg": "e1e3",
	"./notification-outline.svg": "fb78",
	"./notifications-active-bg.svg": "ecb9",
	"./notifications-active.svg": "91af",
	"./notifications-blank.svg": "7f40",
	"./notifications-empty.svg": "95cc",
	"./om.svg": "e67b",
	"./onboarding-category-1.svg": "0faa",
	"./onboarding-category-2.svg": "4f1c",
	"./onboarding-category-3.svg": "69b5",
	"./onboarding-category-4.svg": "c8c6",
	"./onboarding-category-5.svg": "2cc3",
	"./onboarding-hand.svg": "e0fc",
	"./onboarding-manage-orders.svg": "bf58",
	"./onboarding-new-customers.svg": "a8f6",
	"./onboarding-plan-icon-top.svg": "39a9",
	"./onboarding-plan-icon1.svg": "98c0",
	"./onboarding-plan-icon2.svg": "f65e",
	"./onboarding-plan-icon3.svg": "cdfa",
	"./onboarding-platform-1.svg": "e283",
	"./onboarding-platform-2.svg": "710a",
	"./onboarding-platform-3.svg": "3297",
	"./onboarding-platform-5.svg": "1686",
	"./onboarding-platform-6.svg": "f5eb",
	"./onboarding-speed-up.svg": "2ae5",
	"./onboarding-success-check.svg": "2bd2",
	"./online-2.svg": "9061",
	"./online-shoppers-active.svg": "7df9",
	"./online-shoppers.svg": "4a1a",
	"./online.svg": "575e",
	"./opened-cases.svg": "76ec",
	"./order-id.svg": "c710",
	"./order-reference.svg": "8de7",
	"./orders-active.svg": "aea4",
	"./orders.svg": "8577",
	"./other-retail.svg": "2e01",
	"./others-outline.svg": "2b333",
	"./others.svg": "ae54",
	"./outdoor.svg": "6946",
	"./partner-logo.svg": "51bf",
	"./password.svg": "198d",
	"./pause.svg": "b849",
	"./pay-in-full.svg": "9361",
	"./paylater.svg": "141c",
	"./payment-link-active.svg": "e7b8",
	"./payment-link.svg": "a572",
	"./payment-method-american-express.svg": "0f27",
	"./payment-method-diners-club.svg": "cddd",
	"./payment-method-discover.svg": "3e01",
	"./payment-method-jcb.svg": "ee92",
	"./payment-method-mada.svg": "8ff5",
	"./payment-method-maestro.svg": "28dd",
	"./payment-method-mastercard.svg": "c5bd",
	"./payment-method-visa.svg": "3fc2",
	"./payment.svg": "e82e",
	"./paymob.svg": "37da",
	"./paynow.svg": "ea76",
	"./permissions-icon-action.svg": "e2da",
	"./permissions-icon-create.svg": "f59b",
	"./permissions-icon-default.svg": "ac85",
	"./permissions-icon-delete.svg": "1924",
	"./permissions-icon-download.svg": "c9f2",
	"./permissions-icon-edit.svg": "93a7",
	"./permissions-icon-view.svg": "ea97",
	"./personal-service.svg": "1e8b",
	"./personal-services.svg": "72ea",
	"./pets.svg": "5d5f",
	"./picture-empty.svg": "c467",
	"./platform-cashin.svg": "73ec",
	"./platform-dewatech.svg": "2ba0",
	"./platform-direct.svg": "ae49",
	"./platform-expandcart.svg": "6c6f",
	"./platform-fathershops.svg": "ba5d",
	"./platform-mnasati.svg": "cda5",
	"./platform-msaaq.svg": "91c4",
	"./platform-opencart.svg": "ec08",
	"./platform-other.svg": "0662",
	"./platform-ottu.svg": "fae6",
	"./platform-payone.svg": "9c92",
	"./platform-paytabs.svg": "08c0",
	"./platform-prestashop.svg": "ebb4",
	"./platform-rekaz.svg": "0d3e",
	"./platform-salla.svg": "4919",
	"./platform-sary.svg": "2405",
	"./platform-shopify.svg": "0a55",
	"./platform-sure-pay.svg": "fa35",
	"./platform-techrar.svg": "123c",
	"./platform-teem.svg": "5393",
	"./platform-totalpay.svg": "8fa7",
	"./platform-wazin.svg": "f993",
	"./platform-whatsapp.svg": "05f9",
	"./platform-woo.svg": "376d",
	"./platform-zid.svg": "0d17",
	"./play-red.svg": "8845",
	"./play-yellow.svg": "8ac5",
	"./play.svg": "4c1a",
	"./plus-green.svg": "652a",
	"./plus.svg": "701f",
	"./plusOrder.svg": "a4ea",
	"./point-down.svg": "470f",
	"./product-placeholder.svg": "13fd",
	"./professional-service.svg": "be80",
	"./professional-services.svg": "acea",
	"./public-services.svg": "3cc8",
	"./qa.svg": "55db",
	"./qr-order-active.svg": "8ee4",
	"./qr-order.svg": "19b4",
	"./qr.svg": "ba8e",
	"./question-white.svg": "1fda",
	"./question-yellow-round.svg": "2195",
	"./question.svg": "5d9e",
	"./quick-search.svg": "45d3",
	"./radio-active.svg": "fd3f2",
	"./radio-big-active.svg": "da7c",
	"./radio-big-inactive.svg": "18ef",
	"./radio-inactive.svg": "8d39",
	"./ramadan-logo-decorator-ar.svg": "f5d8",
	"./ramadan-logo-decorator.svg": "5f2d",
	"./reach-shoppers.svg": "a483",
	"./real-time-analytics.svg": "ec02",
	"./recaptcha-icon.svg": "12a1",
	"./receipt.svg": "e528",
	"./red-circle-close.svg": "871f",
	"./red-close.svg": "b0fa",
	"./reduced-risk.svg": "bf6a",
	"./reduction-returns.svg": "4c64",
	"./refresh.svg": "b41b",
	"./registered.svg": "54fe",
	"./reload.svg": "8561",
	"./remove-file-cross-white.svg": "7299",
	"./remove-file-cross.svg": "d4c5",
	"./remove.svg": "72b7",
	"./repairs.svg": "5549",
	"./resume.svg": "5cce",
	"./rocket-round.svg": "7ad4",
	"./role-check.svg": "d3cb",
	"./role-uncheck.svg": "9a9e",
	"./sa.svg": "9645",
	"./scan.svg": "f5c3",
	"./scrollLeft.svg": "2ce7",
	"./scrollRight.svg": "60d4",
	"./search-gray.svg": "a19f",
	"./search-purple.svg": "5569",
	"./search.svg": "679a",
	"./services.svg": "512f",
	"./settings-active.svg": "7de1",
	"./settings.svg": "9c15",
	"./settlements-active.svg": "e3e4",
	"./settlements.svg": "23ed8",
	"./sharia-compliant.svg": "3ad6",
	"./size.svg": "879b",
	"./small-flag-ae.svg": "3e03",
	"./small-flag-bh.svg": "46f2",
	"./small-flag-kw.svg": "9c158",
	"./small-flag-om.svg": "33c1",
	"./small-flag-qa.svg": "f719",
	"./small-flag-sa.svg": "c3f1",
	"./sorter.svg": "099f",
	"./spinner-loading.svg": "9505",
	"./split-12.svg": "7890",
	"./split-2.svg": "f487",
	"./split-3.svg": "4456",
	"./split-4.svg": "5116",
	"./split-5.svg": "c754",
	"./split-6.svg": "a5bc",
	"./split-9.svg": "05a2",
	"./split.svg": "e939",
	"./sport-hobby.svg": "0787",
	"./sport.svg": "b254",
	"./sports.svg": "a350",
	"./sports2.svg": "af32",
	"./star-active.svg": "1b30",
	"./star.svg": "4e5a",
	"./store-default.svg": "0e6a",
	"./store-logo-default.svg": "5a62",
	"./store-logo-placeholder.svg": "351d",
	"./store-solid.svg": "22ae",
	"./store.svg": "387f0",
	"./success-confirm.svg": "7b2a",
	"./success-icon.svg": "b958",
	"./success-sign.svg": "30ae",
	"./success-white.svg": "88c0",
	"./success.svg": "ce70",
	"./support-gray.svg": "60de",
	"./support.svg": "7ede",
	"./table-no-data.svg": "8c94",
	"./tamara-ads-active.svg": "5d68",
	"./tamara-ads.svg": "c55e",
	"./tamara-id.svg": "ca33",
	"./tamara-logo-badge.svg": "eea2",
	"./tamara-logo.svg": "d900",
	"./tamara-small-logo.svg": "b3025",
	"./tech-lover-active.svg": "1386",
	"./tech-lover.svg": "90a1",
	"./telecom.svg": "6bed",
	"./telecommunications.svg": "af37",
	"./tools-hardware.svg": "5243",
	"./tools-hardware2.svg": "edee",
	"./tooltip-big-transparent.svg": "30a5",
	"./tooltip-env-ribbon.svg": "7b26",
	"./tooltip-yellow.svg": "3e43",
	"./tooltip.svg": "13a1d",
	"./total-amount.svg": "4509",
	"./transactions-active.svg": "5626",
	"./transactions.svg": "e74a",
	"./transport.svg": "6218",
	"./travel-hospital.svg": "888c",
	"./travel.svg": "5138",
	"./try-order.svg": "7b15",
	"./two-arrows.svg": "0459",
	"./unchecked.svg": "356d",
	"./under-maintenance.svg": "0a5b",
	"./upcoming-default.svg": "93a5",
	"./upcoming-red.svg": "a92d",
	"./upfront-payment.svg": "8b1a0",
	"./upload-asset.svg": "7a1a",
	"./upload-photo.svg": "803e",
	"./uptrend.svg": "d116",
	"./user-admin.svg": "95f4",
	"./user-executive.svg": "6a50",
	"./user-finance.svg": "113b",
	"./user-round-admin.svg": "5a7e",
	"./user-round-executive.svg": "99a0",
	"./user-round-finance.svg": "efec5",
	"./user-round-staff.svg": "93e1",
	"./user-setting.svg": "929a",
	"./user-staff.svg": "da38",
	"./user.svg": "d88a",
	"./users-active.svg": "91e7",
	"./users.svg": "4a04",
	"./view-notes.svg": "15e6",
	"./view.svg": "5a17",
	"./wallet.svg": "7a3e",
	"./warning-circle-blue.svg": "5eeb",
	"./warning-circle-colorless.svg": "2ccb",
	"./warning-circle-lavender.svg": "39ef",
	"./warning-circle-red.svg": "bf69",
	"./warning-circle.svg": "4d68",
	"./warning-filled.svg": "3b77",
	"./warning-yellow.svg": "3790",
	"./warning.svg": "0d95",
	"./warningSing.svg": "2b7e",
	"./webhook-id.svg": "0e7a",
	"./webhooks-active.svg": "af84",
	"./webhooks-no-results.svg": "2d7f",
	"./webhooks.svg": "7a95"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "23f1";